<template>
  <div class="row">
    <div :class="{
      [ $ALERT_COL ]: true,
      'mx-auto': setup
    }">
      <Alert class="alert-info" icon="IconCode" title="Development store">
        <p class="mb-0">Enjoy all features of Pro plan <span class="em-line">absolutely free</span> while your store is under development. <span class="alert-link cursor-pointer" v-if="!showMore" @click="showMore = !showMore">Learn more</span></p>
        <transition name="fade" mode="out-in">
          <div v-if="showMore" class="mt-3 font-weight-normal small">
            <hr>
            <div class="media mb-1">
              <div class="mr-2">1.</div>
              <div class="media-body">
                <p class="mb-0">Once you switch to a Shopify plan, we will automatically switch you to Superchargify's Free plan.</p>
              </div>
            </div>
            <div class="media">
              <div class="mr-2">2.</div>
              <div class="media-body">
                <p class="mb-0">None of your customisations will be lost. You will be able to preview features or upgrade to a plan.</p>
              </div>
            </div>
          </div>
        </transition>
      </Alert>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    setup: Boolean
  },
  data: function () {
    return {
      showMore: false
    }
  }
}
</script>
